import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissionsArray } from '@/shared';
import { useGetProvince } from '@/shared/actions/erp/provinces.actions';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveProvince } from '../../shared/components/SaveProvince';

export type UpdateProvincePageProps = {};

const UpdateProvincePage: React.FC<UpdateProvincePageProps> = () => {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_pais,
    PermissionsEnum.api_change_provincia,
  ]);

  const { id } = useParams();

  const { data, isLoading } = useGetProvince(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_provincia) return <Navigate to="/configuracion/paises" />;

  return <SaveProvince titlePage="Editar Provincia" editProvince={data.data} />;
};

export default UpdateProvincePage;
